import React from 'react';
import './../Style/NEETExamPattern2027.css';
import TopNavbar from '../../../home/TopNavbar';
import TopHeader from '../../../home/TopHeader';

const NEETExamPattern2027 = () => {
  // Overview Table Data
  const overviewData = [
    { feature: 'Exam mode', details: 'Pen-and-paper mode, subject to confirmation' },
    { feature: 'Exam duration', details: '3 hours' },
    { feature: 'Total questions', details: '180 compulsory questions' },
    { feature: 'Question type', details: 'Multiple-choice questions' },
    { feature: 'Subjects', details: 'Physics, Chemistry and Biology' },
    { feature: 'Total marks', details: '720' },
    { feature: 'Correct answer', details: '+4 marks' },
    { feature: 'Incorrect answer', details: '-1 mark' },
    { feature: 'Unanswered question', details: '0 marks' },
    { feature: 'Languages', details: '13 languages' },
  ];

  // Subject-wise Question Distribution Data
  const subjectDistribution = [
    { subject: 'Physics', questions: 45, marks: 180 },
    { subject: 'Chemistry', questions: 45, marks: 180 },
    { subject: 'Biology', questions: 90, marks: 360 },
  ];

  // Marking Scheme Data
  const markingSchemeData = [
    { responseType: 'Correct answer', marks: '+4' },
    { responseType: 'Incorrect answer', marks: '-1' },
    { responseType: 'Unanswered question', marks: '0' },
    { responseType: 'More than one correct option', marks: '+4 for marking a correct option' },
    { responseType: 'Dropped or incorrect question', marks: '+4 as per NTA rules' },
  ];

  return (
    <div className="neetaexampattern-container">
    
    <TopNavbar name="NEET Exam Pattern" ></TopNavbar>
    <TopHeader name="NEET Exam Pattern" ></TopHeader>

      {/* Main Content Area */}
      <main className="neetaexampattern-content">
        <h2 className="neetaexampattern-main-heading">NEET 2027 : Exam Pattern</h2>

        <p className="neetaexampattern-description">
          NEET UG 2027 for admission into MBBS, BDS, BAMS, BUMS, BHMS, BSMS, etc. courses will be conducted by the National Testing Agency (NTA).
        </p>

        <p className="neetaexampattern-description">
          NTA has not yet announced the NEET 2027 Exam Pattern officially. Students should prepare according to the earlier NEET Exam Pattern till the NEET UG 2027 brochure comes out.
        </p>

        {/* Section 1: Overview Table */}
        <section className="neetaexampattern-section">
          <h3 className="neetaexampattern-section-title">NEET 2027 Exam Pattern Overview</h3>
          <div className="neetaexampattern-table-wrapper">
            <table className="neetaexampattern-table">
              <thead>
                <tr>
                  <th>Exam feature</th>
                  <th>Expected details</th>
                </tr>
              </thead>
              <tbody>
                {overviewData.map((row, index) => (
                  <tr key={index}>
                    <td className="neetaexampattern-td-feature">{row.feature}</td>
                    <td className="neetaexampattern-td-details">{row.details}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Section 2: Exam Mode */}
        <section className="neetaexampattern-section">
          <h3 className="neetaexampattern-section-title">NEET 2027 Exam Mode</h3>
          <p className="neetaexampattern-description">
            NEET UG 2026 was held via pen-and-paper mode through OMR sheets. NTA has not yet revealed whether NEET UG 2027 will continue with offline mode or shift to computer-based test mode.
          </p>
          <p className="neetaexampattern-description">
            There can be either pen-and-paper mode for the 2027 examination or NTA can conduct computer-based test mode. Students need to study as per the existing examination pattern till an announcement is made.
          </p>
          <p className="neetaexampattern-description">
            Students need to practice OMR-based mock tests for now. The actual mode of NEET 2027 examination will be mentioned in the information bulletin issued by NTA.
          </p>
        </section>

        {/* Section 3: Subject-wise Question Distribution */}
        <section className="neetaexampattern-section">
          <h3 className="neetaexampattern-section-title">Subject-wise Question Distribution</h3>
          <div className="neetaexampattern-table-wrapper">
            <table className="neetaexampattern-table">
              <thead>
                <tr>
                  <th>Subject</th>
                  <th className="neetaexampattern-th-center">Number of questions</th>
                  <th className="neetaexampattern-th-center">Total marks</th>
                </tr>
              </thead>
              <tbody>
                {subjectDistribution.map((row, index) => (
                  <tr key={index}>
                    <td className="neetaexampattern-td-feature">{row.subject}</td>
                    <td className="neetaexampattern-td-center">{row.questions}</td>
                    <td className="neetaexampattern-td-center">{row.marks}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="neetaexampattern-total-row">
                  <td>Total</td>
                  <td className="neetaexampattern-td-center">180</td>
                  <td className="neetaexampattern-td-center">720</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <p className="neetaexampattern-description neetexampattern-note-text">
            Biology will include questions from Botany and Zoology. All 180 questions are expected to be compulsory.
          </p>
        </section>

        {/* Section 4: Marking Scheme */}
        <section className="neetaexampattern-section">
          <h3 className="neetaexampattern-section-title">NEET 2027 Marking Scheme</h3>
          <div className="neetaexampattern-table-wrapper">
            <table className="neetaexampattern-table">
              <thead>
                <tr>
                  <th>Type of response</th>
                  <th className="neetaexampattern-th-right">Marks</th>
                </tr>
              </thead>
              <tbody>
                {markingSchemeData.map((row, index) => (
                  <tr key={index}>
                    <td className="neetaexampattern-td-feature">{row.responseType}</td>
                    <td className="neetaexampattern-td-right neetaexampattern-td-highlight">
                      {row.marks}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="neetaexampattern-description neetexampattern-note-text">
            Candidates should avoid guessing answers because one mark will be deducted for every incorrect response.
          </p>
        </section>

        {/* Section 5: Language Options */}
        <section className="neetaexampattern-section">
          <h3 className="neetaexampattern-section-title">NEET 2027 Language Options</h3>
          <p className="neetaexampattern-description">
            The NEET UG 2027 exam will be held in 13 languages:
          </p>
          <p className="neetaexampattern-description neetexampattern-lang-box">
            English, Hindi, Urdu, Assamese, Bengali, Gujarati, Marathi, Tamil, Telugu, Odia, Kannada, Malayalam and Punjabi.
          </p>
          <p className="neetaexampattern-description">
            The candidates will need to choose the language for the question paper during the time of filling out the application form. Once submitted, the chosen language cannot be modified further.
          </p>
          <p className="neetaexampattern-description">
            Candidates opting for Hindi or any regional language might get a bilingual question paper with questions in English and chosen language. In case of any discrepancy between the two translations, the English translation will hold precedence.
          </p>
        </section>

        {/* Section 6: Exam-Day Instructions */}
        <section className="neetaexampattern-section">
          <h3 className="neetaexampattern-section-title">NEET 2027 Exam-Day Instructions</h3>
          <p className="neetaexampattern-description">
            Candidates should reach the exam center before the cut-off time of registration. They may not get permission for late entry.
          </p>
          <p className="neetaexampattern-description">
            They should bring their NEET 2027 admit card, passport size photo, and photo identity card.
          </p>
          <p className="neetaexampattern-description">
            Candidates who are taking offline examinations should fill the OMR sheet very carefully. Wrongly marked, half-erased answers and filling outside the bubbles are not considered.
          </p>
          <p className="neetaexampattern-description">
            NEET 2027 exam pattern, mode, time duration and marking scheme will be declared by NTA through information bulletin.
          </p>
        </section>
      </main>

     </div>
  );
};

export default NEETExamPattern2027;